class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.variantSelects = this.querySelectorAll('select[name="id"], .variant-option');
    this.quantityInput = this.querySelector('.quantity-input');
    this.addToCartBtn = this.querySelector('.add-to-cart-btn');

    this.init();
  }

  init() {
    if (this.variantSelects.length) {
      this.variantSelects.forEach(select => {
        select.addEventListener('change', this.onVariantChange.bind(this));
        select.addEventListener('click', this.onVariantClick.bind(this));
      });
    }

    if (this.quantityInput) {
      const minusBtn = this.querySelector('.quantity-minus');
      const plusBtn = this.querySelector('.quantity-plus');

      if (minusBtn) minusBtn.addEventListener('click', () => this.updateQuantity(-1));
      if (plusBtn) plusBtn.addEventListener('click', () => this.updateQuantity(1));
    }

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  onVariantClick(e) {
    const option = e.target.closest('.variant-option');
    if (!option || option.classList.contains('disabled')) return;

    const container = option.closest('.variant-options');
    container.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
    option.classList.add('selected');

    const input = option.closest('.variant-selector').querySelector('input[type="hidden"]');
    if (input) input.value = option.dataset.value;

    this.onVariantChange();
  }

  onVariantChange() {
    const selectedOptions = [];
    this.querySelectorAll('.variant-selector').forEach(selector => {
      const selected = selector.querySelector('.variant-option.selected, select');
      if (selected) {
        selectedOptions.push(selected.value || selected.dataset?.value);
      }
    });

    const variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const variant = variants.find(v => {
      return v.options.every((opt, i) => opt === selectedOptions[i]);
    });

    if (variant) {
      const input = this.querySelector('input[name="id"]');
      if (input) input.value = variant.id;

      const priceEl = this.querySelector('.price-current');
      if (priceEl) priceEl.textContent = Shopify.formatMoney(variant.price);

      if (!variant.available) {
        this.addToCartBtn.textContent = 'Sold Out';
        this.addToCartBtn.disabled = true;
      } else {
        this.addToCartBtn.textContent = 'Add to Cart';
        this.addToCartBtn.disabled = false;
      }
    }
  }

  updateQuantity(change) {
    const current = parseInt(this.quantityInput.value) || 1;
    const newQty = Math.max(1, current + change);
    this.quantityInput.value = newQty;
  }

  async onSubmit(e) {
    e.preventDefault();

    if (this.addToCartBtn.disabled) return;

    this.addToCartBtn.textContent = 'Adding...';
    this.addToCartBtn.disabled = true;

    const formData = new FormData(this.form);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        this.showToast('Item added to cart!', 'success');
        this.updateCartCount();
        this.addToCartBtn.textContent = 'Add to Cart';
        this.addToCartBtn.disabled = false;
      } else {
        throw new Error(data.description || 'Error adding to cart');
      }
    } catch (error) {
      this.showToast(error.message, 'error');
      this.addToCartBtn.textContent = 'Add to Cart';
      this.addToCartBtn.disabled = false;
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countElements = document.querySelectorAll('.cart-count');
      countElements.forEach(el => el.textContent = cart.item_count);
    } catch (e) {
      console.error('Error updating cart count:', e);
    }
  }

  showToast(message, type = 'success') {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.innerHTML = `
      <span>${type === 'success' ? '✓' : '✗'}</span>
      <span>${message}</span>
    `;
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('show');
    });

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 400);
    }, 3000);
  }
}

customElements.define('product-form', ProductForm);
